import type { IPredictionCenterPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import { useSite } from '@on3/ui-lib/index';
import { capitalizeFirstLetter } from '@on3/ui-lib/utils/capitalizeFirstLetter';
import { PredictionCenterList } from 'components/Db/PredictionCenter/PredictionCenterList';
import { DatabaseLayout } from 'components/Layouts/DatabaseLayout';
import { useRouter } from 'next/router';

export const PredictionListCenterPage = (props: IPredictionCenterPageProps) => {
  const { currentSite } = useSite();
  const name =
    currentSite?.organization?.knownAs ?? currentSite?.organization?.name;
  const router = useRouter();
  const { year, sport } = router.query;
  const sportTitle = sport && capitalizeFirstLetter(sport.toString());
  const title = `${year} ${
    (!currentSite?.isNational && name) || ''
  } ${sportTitle} Expert Predictions`;

  return (
    <DatabaseLayout>
      <PredictionCenterList
        {...props}
        key={`${currentSite?.key}-${props.predictions?.list?.length}-${sport}-${year}`}
        title={title}
      />
    </DatabaseLayout>
  );
};
